/* === AM_HOME_WAVE4 (2026-07-12, v1) — heritage authority band (parked lander section revived) + product-tagged
   review pull-quotes (real Loox reviews, verbatim) + founder/family closer rebuild (photo + signature + About CTA).
   NEW MECHANIC: this wave lives in its OWN asset (am-home-wave4.js, loaded from theme.liquid via asset_url =
   auto cache-busted). It also re-points the am-home.css link to ?v=amh15 so custom.js (still at V='14') needs no re-push.
   Draft theme only. CSS in am-home.css v15. === */
(function(){
  if(window.location.pathname!=='/' && window.location.pathname!=='/index'){ return; }
  var CSS_V='16';
  var FAMILY_IMG='https://allmoringatree.com/cdn/shop/files/all-moringa-founders-family-photo_1200x.jpg?v=1766883349';
  function quoteCard(quote,name,prod,href,stars){
    var s=''; for(var i=0;i<5;i++){ s+= i<stars ? '★' : ''; }
    return '<figure class="am-q"><div class="am-q__stars" style="color:var(--am-gold,#C9A24B);font-size:.95rem;letter-spacing:2px;margin-bottom:10px;">'+s+'</div><blockquote>“'+quote+'”</blockquote><figcaption><strong>'+name+'</strong><span>Verified buyer</span><a href="'+href+'">'+prod+' →</a></figcaption></figure>';
  }
  function build(){
    try{
      /* 0. am-home.css freshness: custom.js still appends ?v=amh14; re-point to v15 */
      var cssLink=document.getElementById('am-home-css');
      if(cssLink && cssLink.href.indexOf('v=amh'+CSS_V)===-1){
        cssLink.href=cssLink.href.split('?')[0]+'?v=amh'+CSS_V;
      }
      /* 0b intentionally removed: am-reskin's "#main p:not(.h1)...:not(.h6){Inter !important}" outranks any
         class-rule fix; the signature serif is forced INLINE in step 3 (inline+!important beats all sheets). */
      /* 1. HERITAGE AUTHORITY BAND — before the comparison-chart section */
      var chartSec=document.getElementById('am-compare');
      var chartHost=chartSec?chartSec.closest('.shopify-section'):null;
      if(chartHost && !document.getElementById('am-heritage')){
        var her=document.createElement('section');
        her.id='am-heritage';
        her.className='am-heritage';
        her.innerHTML=
          '<div class="am-heritage__inner">'+
          '<div class="am-eyebrow am-heritage__eyebrow">Why trust this</div>'+
          '<h2>Some brands buy their credibility.<br>Ours <em>grew</em> on a tree.</h2>'+
          '<div class="am-heritage__cols">'+
          '<div class="am-hcard am-hcard--them"><span class="am-hcard__tag">The usual way</span><h3>Pay the doctors. Build the advisory board.</h3><p>Hire a panel of physicians. License a celebrity name. Print the endorsements on the box. It is a real strategy, and it is expensive, which is part of why the pill costs what it costs.</p></div>'+
          '<div class="am-hcard am-hcard--us"><span class="am-hcard__tag">Our way</span><h3>We did not have to.</h3><p>The leaf has been trusted across India and Africa for thousands of years, rooted in Ayurvedic tradition and grown by families who never needed a marketing budget to believe in it. We inherited that. We did not buy it. Time already did the convincing.</p></div>'+
          '</div></div>';
        chartHost.parentNode.insertBefore(her,chartHost);
      }
      /* 2. PRODUCT-TAGGED REVIEW PULL-QUOTES — after the Loox carousel section (real reviews, verbatim) */
      var loox=document.querySelector('#main [id*="loox_testimonial_carousel"]');
      var looxHost=loox?loox.closest('.shopify-section'):null;
      /* Carousel REMOVED per Tzvi 2026-07-13 ("floating randomly, weak reviews"); the curated
         product-tagged quote cards below are the section's proof now. */
      if(loox){
        var blk=loox.closest('.shopify-block')||loox;
        blk.style.display='none';
      }
      if(looxHost && !document.getElementById('am-quotes')){
        var q=document.createElement('div');
        q.id='am-quotes';
        q.className='am-quotes';
        q.innerHTML=
          /* Star counts are the REAL ratings: Jennifer 4/5 (on file, HANDOFF_capsule_static_ads), Cricket + Sarah 5/5 (verified from Loox widget aria-labels 2026-07-13). Never inflate. */
          quoteCard('It doesn’t feel like a stimulant. It feels like real nourishment.','Jennifer A.','Moringa Capsules','/products/organic-moringa-capsules',4)+
          quoteCard('The best thing is I don’t have to use any other product! It hydrates and balances my skin perfectly.','Cricket A.','Moringa Seed Oil','/products/organic-moringa-oil',5)+
          quoteCard('Best face cream I have tried in years.','Sarah S.','Moringa Face Cream','/products/therapeutic-organic-moringa-moisturizing-face-cream-anti-wrinkle-aging',5);
        looxHost.appendChild(q);
      }
      /* 3. FOUNDER / FAMILY CLOSER — rebuild the old overlay closer (also removes its em dash) */
      var closer=document.querySelector('#main .overlay-img-text');
      if(closer && !closer.getAttribute('data-am-founder')){
        closer.setAttribute('data-am-founder','1');
        closer.innerHTML=
          '<div class="am-founder">'+
          '<div class="am-founder__img"><img src="'+FAMILY_IMG+'" alt="Maya, Tzvi and their daughters, the All Moringa family" loading="eager"></div>'+
          '<div class="am-founder__text">'+
          '<div class="am-eyebrow">From our family to yours</div>'+
          '<h2>Welcome to the Moringa family</h2>'+
          '<p>Once upon a time, this is how people learned of great things: by word of mouth, from people who cared. We are Maya and Tzvi, and with our two daughters we run All Moringa the same way. One family, sharing one remarkable tree with yours.</p>'+
          '<p class="am-founder__sig">Maya &amp; Tzvi</p>'+
          '<div class="am-founder__ctas"><a class="am-founder__btn" href="/pages/about-us">Read our story</a><a class="am-founder__link" href="/collections/all">Shop best sellers</a></div>'+
          '</div></div>';
        var sg=closer.querySelector('.am-founder__sig');
        if(sg){sg.style.setProperty('font-family','var(--am-serif)','important');}
      }
      /* 4. RITUAL image swap (Tzvi pick 2026-07-13): real in-use lifestyle shots replace the packshots.
         Order matches the 3 cards: 01 morning capsules-in-palm, 02 evening oil-on-face, 03 leaf+seed duo
         (card 3 swapped 2026-07-27 per Tzvi go: the golden-drop macro never depicted "together"; the duo
         packshot of oil + capsules does — file am-ritual-duo-v1.png, preserved copy of the router v2 shot). */
      var R_IMGS=[
        ['https://cdn.shopify.com/s/files/1/2131/9649/files/am-ritual-morning-v1.jpg?v=1783990195','Taking All Moringa capsules with water in the morning','50% 58%'],
        ['https://cdn.shopify.com/s/files/1/2131/9649/files/am-ritual-evening-v1.jpg?v=1783990195','Applying All Moringa seed oil to the face in the evening','50% 30%'],
        ['https://cdn.shopify.com/s/files/1/2131/9649/files/am-ritual-duo-v1.png?v=1785180164','All Moringa cold-pressed seed oil bottle and capsules jar together on warm linen, the Inside-Out Starter Duo','50% 50%']
      ];
      var rimgs=document.querySelectorAll('#am-ritual .am-rstep__img img');
      for(var ri=0;ri<rimgs.length&&ri<R_IMGS.length;ri++){
        if(rimgs[ri].getAttribute('src')!==R_IMGS[ri][0]){
          rimgs[ri].setAttribute('loading','eager');
          rimgs[ri].setAttribute('src',R_IMGS[ri][0]);
          rimgs[ri].setAttribute('alt',R_IMGS[ri][1]);
          rimgs[ri].style.objectPosition=R_IMGS[ri][2];
        }
      }
    }catch(e){}
  }
  if(document.readyState!=='loading'){build();}else{document.addEventListener('DOMContentLoaded',build);}
  window.addEventListener('load',build);
  setTimeout(build,1200);setTimeout(build,3000);
})();
/* === end AM_HOME_WAVE4 === */